module.exports = __webpack_public_path__ + "static/img/flexisaf-main.fb54403.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/flexisaf-main.png
// module id = zUYA
// module chunks = 1